import type { InputHTMLAttributes } from "react";
import { cn } from "../cn.ts";

export type InputProps = InputHTMLAttributes<HTMLInputElement>;

export function Input({ className, ...rest }: InputProps) {
  return (
    <input
      className={cn(
        "block w-full px-3 py-2 rounded-[var(--radius-md)]",
        "bg-[var(--color-surface)] border border-[var(--color-border)]",
        "focus-visible:outline-2 focus-visible:outline-offset-0 focus-visible:outline-[var(--color-accent)]",
        "placeholder:text-[var(--color-muted)]",
        className,
      )}
      {...rest}
    />
  );
}
